import React, { useState, useEffect } from 'react';
import { UserRole } from '../data/auth';
import ConsultantRegistration from './ConsultantRegistration';
import CompanyRegistration from './CompanyRegistration';
import SiteRegistration from './SiteRegistration';
import './Register.css';

interface RegisterProps {
  onRegisterSuccess: () => void;
  onSwitchToLogin: () => void;
}

const Register: React.FC<RegisterProps> = ({ onRegisterSuccess, onSwitchToLogin }) => {
  const [selectedRole, setSelectedRole] = useState<UserRole | null>(null);
  const [referrerId, setReferrerId] = useState<string | null>(null);

  useEffect(() => {
    // Check for referral ID in URL
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      setReferrerId(ref);
    }
  }, []);

  if (!selectedRole) {
    return (
      <div className="register-page">
        <div className="register-container role-selection-container">
          <div className="register-header">
            <h1>Create Your Account</h1>
            <p>Choose your account type to get started</p>
          </div>

          <div className="role-selection">
            <div className="role-card" onClick={() => setSelectedRole('professional')}>
              <div className="role-icon">👨‍⚕️</div>
              <h3>Consultant Account</h3>
              <p>For individual clinical trial professionals, researchers, and consultants</p>
              <ul>
                <li>Create professional profile</li>
                <li>Apply to job postings</li>
                <li>Showcase expertise</li>
                <li>Connect with companies</li>
              </ul>
              <button className="select-button">Select</button>
            </div>

            <div className="role-card" onClick={() => setSelectedRole('company')}>
              <div className="role-icon">🏢</div>
              <h3>Company Account</h3>
              <p>For pharmaceutical companies and CROs</p>
              <ul>
                <li>Post job opportunities</li>
                <li>Find qualified consultants</li>
                <li>Manage projects</li>
                <li>Build your team</li>
              </ul>
              <button className="select-button">Select</button>
            </div>

            <div className="role-card site-card" onClick={() => setSelectedRole('site')}>
              <div className="role-icon">🏥</div>
              <h3>Clinical Trial Site</h3>
              <p>For clinical trial research sites across South Africa</p>
              <ul>
                <li>FREE membership</li>
                <li>Get discovered by sponsors</li>
                <li>Showcase capabilities</li>
                <li>Receive RFPs</li>
              </ul>
              <div className="free-badge">FREE</div>
              <button className="select-button">Select</button>
            </div>
          </div>

          <div className="register-footer">
            <p>
              Already have an account?{' '}
              <button onClick={onSwitchToLogin} className="link-button">
                Sign in here
              </button>
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (selectedRole === 'professional') {
    return (
      <ConsultantRegistration
        onSuccess={onRegisterSuccess}
        onBack={() => setSelectedRole(null)}
        referrerId={referrerId}
      />
    );
  }

  if (selectedRole === 'company') {
    return (
      <CompanyRegistration
        onSuccess={onRegisterSuccess}
        onBack={() => setSelectedRole(null)}
        referrerId={referrerId}
      />
    );
  }

  if (selectedRole === 'site') {
    return <SiteRegistration onSuccess={onRegisterSuccess} onBack={() => setSelectedRole(null)} />;
  }

  return null;
};

export default Register;
